var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationPodPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14V9C9 7.34315 10.3431 6 12 6H14M18 30H28C29.6569 30 31 28.6569 31 27V9C31 7.34315 29.6569 6 28 6H25",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 5.76948C14.7559 5.42854 15.4864 4.71531 15.987 4.5848C16.4095 4.47461 16.7352 4.1811 16.8568 3.7988C17.187 2.75998 18.2453 2 19.4999 2C20.7545 2 21.8129 2.76003 22.1432 3.7989C22.2646 4.18073 22.5894 4.47461 23.0115 4.58438C23.5126 4.71479 24.0774 5.42828 24.4169 5.76948C24.5184 6.02909 25 6.68457 25 6.9756V7C25 7.55229 24.5523 8 24 8H15C14.4477 8 14 7.55228 14 7V6.95575C14.0024 6.67203 14.3176 6.08509 14.4167 5.83154",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4488 15H16.55C16.2462 15 16 15.2462 16 15.55C16 15.8537 16.2462 16.1 16.55 16.1H23.4488C23.7526 16.1 23.9988 15.8537 23.9988 15.55C23.9988 15.2462 23.7526 15 23.4488 15Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4498 19H16.551C16.2472 19 16.001 19.2462 16.001 19.55C16.001 19.8537 16.2472 20.1 16.551 20.1H23.4498C23.7535 20.1 23.9998 19.8537 23.9998 19.55C23.9998 19.2462 23.7535 19 23.4498 19Z",
    fill: "white",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71429,
    cy: 24.7143,
    r: 7.71429,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49414 28.9965C6.78929 28.9718 7.05931 28.8206 7.23449 28.5818L11.4892 22.7815C11.8236 22.3257 11.7251 21.6851 11.2692 21.3507C10.8134 21.0163 10.1728 21.1148 9.83837 21.5706L6.27952 26.4223L4.7374 24.9223C4.33215 24.5281 3.68406 24.537 3.28987 24.9423C2.89568 25.3476 2.90465 25.9956 3.30991 26.3898L5.69534 28.7101C5.90765 28.9166 6.19899 29.0211 6.49414 28.9965Z",
    fill: "#06CEA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPodPositive);
export default __webpack_public_path__ + "static/media/notification-pod-positive.b1922c8dbfa4aad532d09bde7275b552.svg";
export { ForwardRef as ReactComponent };